import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';

import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Categories from './pages/Categories';
import Clients from './pages/Clients';
import Invoices from './pages/Invoices';
import CreateInvoice from './pages/CreateInvoice';
import InvoiceView from './pages/InvoiceView';
import EditInvoice from './pages/EditInvoice';
import BatchManagement from './pages/BatchManagement';
import DirectFbrSubmission from './pages/DirectFbrSubmission';
import BatchInvoices from './pages/BatchInvoices';
import Settings from './pages/Settings';
import ProFeatures from './pages/ProFeatures';
import Subscription from './pages/Subscription';
import AdminDashboard from './pages/admin/Dashboard';
import AdminTenants from './pages/admin/Tenants';
import AdminUsers from './pages/admin/Users';
import AdminPayments from './pages/admin/Payments';
import MarketingHome from './pages/MarketingHome';
import FbrInvoicing from './pages/marketing/FbrInvoicing';
import PraInvoicing from './pages/marketing/PraInvoicing';
import TaxFiling from './pages/marketing/TaxFiling';
import OdooIntegration from './pages/marketing/OdooIntegration';
import AdminSiteAnalytics from './pages/admin/SiteAnalytics';
import SiteAnalyticsTracker from './components/SiteAnalyticsTracker';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          {/* Mounts the renderer for react-hot-toast. Without this every toast.* call in the
              app is a silent no-op, which is why API errors were invisible to users. */}
          <Toaster
            position="top-right"
            toastOptions={{ duration: 5000, error: { duration: 8000 } }}
          />
          {/* First party page view tracking. Marketing routes only, never blocks. */}
          <SiteAnalyticsTracker />

          <Routes>
            {/* Marketing Routes */}
            <Route path="/" element={<MarketingHome />} />
            <Route path="/fbr-digital-invoicing" element={<FbrInvoicing />} />
            <Route path="/pra-digital-invoicing" element={<PraInvoicing />} />
            <Route path="/tax-filing" element={<TaxFiling />} />
            <Route path="/odoo-integration" element={<OdooIntegration />} />

            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />

            <Route path="/products" element={
              <PrivateRoute>
                <Products />
              </PrivateRoute>
            } />
            <Route path="/categories" element={
              <PrivateRoute>
                <Categories />
              </PrivateRoute>
            } />

            <Route path="/clients" element={
              <PrivateRoute>
                <Clients />
              </PrivateRoute>
            } />

            <Route path="/invoices" element={
              <PrivateRoute>
                <Invoices />
              </PrivateRoute>
            } />

            <Route path="/create-invoice" element={
              <PrivateRoute>
                <CreateInvoice />
              </PrivateRoute>
            } />

            <Route path="/invoices/:id/view" element={
              <PrivateRoute>
                <InvoiceView />
              </PrivateRoute>
            } />

            <Route path="/invoices/:id/edit" element={
              <PrivateRoute>
                <EditInvoice />
              </PrivateRoute>
            } />


            <Route path="/batch-management" element={
              <PrivateRoute>
                <BatchManagement />
              </PrivateRoute>
            } />

            <Route path="/direct-fbr-submission" element={
              <PrivateRoute>
                <DirectFbrSubmission />
              </PrivateRoute>
            } />

            <Route path="/batch/:batchId/invoices" element={
              <PrivateRoute>
                <BatchInvoices />
              </PrivateRoute>
            } />

            <Route path="/settings" element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            } />

            <Route path="/pro" element={
              <PrivateRoute>
                <ProFeatures />
              </PrivateRoute>
            } />

            <Route path="/pro/:feature" element={
              <PrivateRoute>
                <ProFeatures />
              </PrivateRoute>
            } />

            <Route path="/subscription" element={
              <PrivateRoute>
                <Subscription />
              </PrivateRoute>
            } />

            {/* Admin Routes */}
            <Route path="/admin" element={
              <PrivateRoute adminOnly={true}>
                <AdminDashboard />
              </PrivateRoute>
            } />

            <Route path="/admin/tenants" element={
              <PrivateRoute adminOnly={true}>
                <AdminTenants />
              </PrivateRoute>
            } />

            <Route path="/admin/users" element={
              <PrivateRoute adminOnly={true}>
                <AdminUsers />
              </PrivateRoute>
            } />

            <Route path="/admin/payments" element={
              <PrivateRoute adminOnly={true}>
                <AdminPayments />
              </PrivateRoute>
            } />

            <Route path="/admin/site-analytics" element={
              <PrivateRoute adminOnly={true}>
                <AdminSiteAnalytics />
              </PrivateRoute>
            } />

            {/* Default redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;